import React from "react";
import { Chip } from "@mui/material";

interface IProps {
    removeFilterFn?: (filterName:string, filterValue:string) => void;
    filterId?:string;
    filterName?: string;
    filterValue?: string;
    filterParent?: string;
}

// const styles = {
//     chip: {
//         marginRight: 10,
//         maxWidth: "100%",
//     },
// };

export function DashChip(props: IProps) {
    const { filterName, filterValue, removeFilterFn, filterId, filterParent } = props;

    let title = (filterParent ? filterName + ": " + filterParent + " - " + filterValue : filterName + ": " + filterValue);
    // if(filterValue)
    //     title += `: ${filterValue}`;

    return <Chip
            onDelete={() => removeFilterFn && removeFilterFn(filterId, filterValue)}
            label={title}
            title={title}
            // style={styles.chip}
        />;
}